import { FontAwesomeIcon } from '@appcharge/shared-ui';

import Button from 'components/Button/Button';

import { IDataTablePaginationProps } from '../DataTable.types';

const DataTablePagination = <T,>({
  table,
  rowCount
}: IDataTablePaginationProps<T>) => {
  const { pageIndex, pageSize } = table.getState().pagination;
  const totalRows = rowCount ?? table.getFilteredRowModel().rows.length;

  const startItem = totalRows > 0 ? pageIndex * pageSize + 1 : 0;
  const endItem = Math.min((pageIndex + 1) * pageSize, totalRows);

  return (
    <div className="flex items-center justify-between py-4 w-full">
      <div className="text-sm text-base-mutedForeground">
        Showing {startItem}-{endItem} of {totalRows} rows
      </div>
      <div className="flex items-center gap-2">
        <Button
          data-testid="PagesTable-PrevButton"
          onClick={() => table.setPageIndex(pageIndex - 1)}
          disabled={!table.getCanPreviousPage()}
          variant="secondary"
        >
          <FontAwesomeIcon icon="fa-solid fa-chevron-left" />
        </Button>
        <Button
          data-testid="PagesTable-NextButton"
          onClick={() => table.setPageIndex(pageIndex + 1)}
          disabled={!table.getCanNextPage()}
          variant="secondary"
        >
          <FontAwesomeIcon icon="fa-solid fa-chevron-right" />
        </Button>
      </div>
    </div>
  );
};

export default DataTablePagination;
